export enum VendorStatusEnum {
  PENDING = "PENDING",
  VERIFIED = "VERIFIED",
  ACTIVE = "ACTIVE",
  LOCKED = "LOCKED"
}
